module.exports = __webpack_public_path__ + "brain_o.422c9b30928359574023021793bd34e6.svg";